import React              from 'react'
import ReactDOM           from 'react-dom'
import BaseController     from 'controllers/base'
import ContactForm        from 'containers/ContactForm/App'
import OurLoansCalculator from 'containers/OurLoansCalculator/App'
import HowToApply from 'containers/HowToApply/App'
import AboutUs from 'containers/AboutUs/App'
import ArchivedTargetMarket from 'containers/ArchivedTargetMarketDeterminations/App'
import MainFooter from 'containers/common/components/MainFooter'
import 'scrollpos-styler/scrollPosStyler.js'

class Controller extends BaseController {
  call() {
    super.call()

    const domArchivedTargetMarket = document.getElementById('archived-target')
    if (domArchivedTargetMarket) {
      ReactDOM.render(<ArchivedTargetMarket />, domArchivedTargetMarket)
    }

    const domAboutUs = document.getElementById('about-us')
    if (domAboutUs) {
      ReactDOM.render(<AboutUs />, domAboutUs)
    }

    const domContactForm = document.getElementById('contact-form')
    if (domContactForm) {
      ReactDOM.render(<ContactForm />, domContactForm)
    }

    const domOurLoansCalculator = document.getElementById('our-rates-calculator')
    if (domOurLoansCalculator) {
      ReactDOM.render(<OurLoansCalculator />, domOurLoansCalculator)
    }

    const howToApply = document.getElementById('how-to-apply-loan')
    if (howToApply) {
      ReactDOM.render(<HowToApply />, howToApply)
    }

    const pricingPlans = document.getElementById('pricing-plans')
    if (pricingPlans) {
      ReactDOM.render(<OurLoansCalculator />, domOurLoansCalculator)
    }
    const domMainFooter = document.getElementById('yard-main-footer')
    if (domMainFooter) {
      ReactDOM.render(<MainFooter />, domMainFooter)
    }

    //TODO: remove if we don't use this anymore
    function openHubSpot() {
      window.HubSpotConversations.widget.open()
    }

    //TODO: remove if we don't use this anymore
    if (document.getElementById('hubspot-chat')) {
      if (window.HubSpotConversations) {
        console.log('The api is ready already');
      } else {
        window.hsConversationsOnReady = [
          () => {
            document.getElementById('hubspot-chat').onclick = openHubSpot
          },
        ];
      }
    }
  }
}

export default Controller
